class SetPasswordEmailController {

    constructor(integrationApiService, messageService) {
        this.integrationApiService = integrationApiService;
        this.messageService = messageService;
    }

    $onInit () {

    }

    onSave () {
        this.messageService.clear();

        return this.integrationApiService.setEmailPasswords({ file: this.csv })
            .then(response => {
                this.csv = undefined;
                this.messageService.success('Emails successfully queued');
                this.messageService.push();
            })
            .catch((error) => {
                this.messageService.failure(error);
                this.messageService.push();
            });
    }

}

SetPasswordEmailController.$inject = ['integrationApiService', 'messageService'];

export default SetPasswordEmailController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/user/controllers/email.setPassword.controller.js